<script>
import Layout from '@/components/layout/app-layout'
import appConfig from '@/app.config'
import PageHeader from '@/components/layout/page-header'
import tableMixin from '@/mixins/table'
import productListHelper from './helpers'
import api from '@/helpers/api'
/**
 * Dashboard Component
 */
export default {
  name: 'products.list',
  mixins: [tableMixin, productListHelper],
  page: {
    title: 'Products',
    meta: [{ name: 'description', content: appConfig.description }]
  },

  data () {
    return {
      isLoading: false,
      title: 'Products Available for Sale',
      search: null,
      isSelectedAll: false,
      selected: [],
      showForm: false,
      fields: [
        {
          key: 'code',
          label: 'Code',
          sortDirection: 'desc',
          class: 'text-left align-middle'
        },

        {
          key: 'sales_price',
          label: 'Sales Price',
          thStyle: { width: '180px' },
          class: 'text-right align-middle'
        },
        {
          key: 'stock_level',
          label: 'Inventory',
          thStyle: { width: '120px' },
          class: 'text-center align-middle'
        },
        {
          key: 'category_id',
          label: 'Category',
          sortDirection: 'desc',
          thStyle: { width: '150px' },
          class: 'text-left align-middle'
        },
        {
          key: 'actions',
          label: '',
          sortable: false,
          thStyle: { width: '100px' },
          class: 'text-right align-middle'
        }
      ]
    }
  },

  mounted () {
    this.onRefresh()
  },
  methods: {
    onNewHandler () {
      this.showForm = true
    }
  },
  computed: {
    breadcrumbs () {
      return [
        {
          text: 'Sales',
          to: { name: 'sales' }
        },
        {
          text: 'Products',
          active: true
        }
      ]
    },
    filters () {
      return [{ is_sellable: { _eq: true } }]
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="breadcrumbs" />
    <g-overlay :show="isLoading">
      <b-card>
        <div class="mb-4 d-flex justify-content-between align-items-center">
          <g-search-input
            v-model="search"
            placeholder="Find Products"
            width="300px"
            class="mr-0 mr-2"
          /><b-btn
            class="btn-label"
            variant="primary"
            v-on:click="onNewHandler"
          >
            <i class="bx bx-plus label-icon"></i>New Product
          </b-btn>
        </div>
        <b-table
          show-empty
          :items="data"
          :fields="fields"
          :busy="isLoading"
          head-variant="primary"
          borderless
          thead-tr-class="bg-light"
          tbody-tr-class="border-bottom mb-5"
        >
          <template v-slot:cell(category_id)="row">
            <h6 class="mb-0" v-if="row.item.category_id">
              <span
                class="badge py-2 text-uppercase font-size-12"
                :class="[
                  `badge-soft-${
                    row.item.category.parent_category_id ? 'secondary' : 'info'
                  }`
                ]"
                style="min-width: 130px"
                >{{ row.item.category.name }}</span
              >
            </h6>
          </template>
          <template v-slot:cell(sales_price)="row">
            {{ row.value.toFixed(2) }}
            <small>EUR</small>
          </template>
          <template v-slot:cell(stock_level)="row">
            <div
              class="mb-0 rounded"
              v-if="row.item.is_stock_item"
              style="position: relative; overflow: hidden"
            >
              <span
                class="badge py-2 text-uppercase font-size-12"
                :class="[`badge-soft-${row.item.stock_color}`]"
                style="width: 100%"
                >{{ row.item.stock_level }} /
                {{ row.item.default_stock_level }}</span
              >
              <div
                style="
                  height: 3px;
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  right: 0;
                "
              >
                <div
                  :class="[`bg-${row.item.stock_color}`]"
                  style="height: 100%"
                  :style="{ width: `${row.item.stock_level_percentage}%` }"
                ></div>
              </div>
            </div>

            <span v-else>-NA-</span>
          </template>
          <template v-slot:cell(code)="row">
            <router-link
              class="text-dark"
              :to="{
                name: 'products.view',
                params: { id: row.item.id }
              }"
              ><div class="d-flex flex-column">
                {{ row.value }}<small>{{ row.item.short_description }}</small>
              </div></router-link
            >
          </template>

          <template v-slot:cell(actions)="row">
            <div class="d-flex align-items-center m-0 p-0">
              <b-button
                variant="link"
                size="sm"
                :to="{
                  name: 'products.view',
                  params: { id: row.item.id }
                }"
                class="align-self-center mr-1"
              >
                <i class="far fa-edit"></i>
              </b-button>
              <b-button
                variant="link"
                size="sm"
                @click="onRemove(row.item)"
                class="align-self-center"
              >
                <i class="far fa-trash-alt text-danger"></i>
              </b-button>
            </div>
          </template>
        </b-table>

        <div class="d-flex align-items-center justify-content-between p-0 mt-2">
          <div class="dataTables_length" v-if="totalRows > minPerPage">
            <label class="d-inline-flex align-items-center m-0">
              Show
              <b-form-select
                v-model="perPage"
                size="sm"
                :options="pageOptions"
                class="mx-2"
              ></b-form-select
              >Entries
            </label>
          </div>

          <b-pagination
            v-if="perPage !== 'All' && totalRows > perPage"
            class="pagination mb-0"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            size="sm"
          >
            <template v-slot:page="{ page, active }">
              <b v-if="active">{{ page }}</b>
              <i v-else>{{ page }}</i>
            </template>
          </b-pagination>
        </div>
      </b-card>
    </g-overlay>
    <app-product-form-dialog
      :visible.sync="showForm"
      v-on:created="onNewProductCreated"
      :preset="{ is_sellable: true }"
    />
  </Layout>
</template>
